import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { UnlockedLevelContainer } from "./UnlockedLevelContainer";

export class ClearedBoardLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x000000);
        darkLayer.alpha = 0;
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        this.scene.tweens.add({
            targets: darkLayer,
            alpha: .6,
            duration: 20000,
            ease: Phaser.Math.Easing.Linear
        });

        const scaledItemsContainer = new Phaser.GameObjects.Container(scene); 
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleX = .9 * GameVars.scaleX;
        scaledItemsContainer.scaleY = .9;
        scaledItemsContainer.alpha = 0;
        this.add(scaledItemsContainer);

        const levelTitleBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "level_title_background");
        scaledItemsContainer.add(levelTitleBackground);

        const menuTitleBackground = new Phaser.GameObjects.Image(this.scene, -255, -55, "texture_atlas_1", "tab_boards_daily_games");
        menuTitleBackground.setOrigin(0);
        scaledItemsContainer.add(menuTitleBackground);

        const levelTitle = new Phaser.GameObjects.Text(this.scene, menuTitleBackground.x + 25, menuTitleBackground.y + 20, gameText.BOARD_CLEARED[lan], {fontFamily: "OpenSans-CondLight", fontSize: "52px", color: "#7C5D46"});
        levelTitle.setOrigin(0);
        scaledItemsContainer.add(levelTitle);

        // if (!(GameVars.levelUnlocked && GameConstants.REWARDED_ADS)) {
        //     if (levelTitle.width > 370) {
        //         levelTitle.setScale(370 / levelTitle.width, 370 / levelTitle.width);
        //     }
        // }

        const nextLevelButton = new Button(this.scene, 200, -4, "texture_atlas_1", "btn_next_off", "btn_next_on");
        nextLevelButton.onDown(this.onClickNextLevel, this);
        scaledItemsContainer.add(nextLevelButton);

        let capsule: Phaser.GameObjects.Graphics;
        let iconHourglass: Phaser.GameObjects.Image;
        let bestScoreLabel: Phaser.GameObjects.Text;
  
        if (GameVars.bestTime) {

            capsule = new Phaser.GameObjects.Graphics(this.scene);
            capsule.fillStyle(0x000000, .3);
            capsule.fillRoundedRect(-160, 85, 320, 60, 30);
            scaledItemsContainer.add(capsule);

            iconHourglass = new Phaser.GameObjects.Image(this.scene, -124, 115, "texture_atlas_1", "icon_hourglass");
            scaledItemsContainer.add(iconHourglass);

            bestScoreLabel = new Phaser.GameObjects.Text(this.scene, 14, 115,  gameText.NEW_BEST_TIME[lan] + " " + GameVars.formatTime(GameVars.bestTime), {fontFamily: "Arial", fontSize: "27px", color: "#FFF4A8", fontStyle: "bold"});
            bestScoreLabel.setOrigin(.5);
            bestScoreLabel.scaleX = .8;
            scaledItemsContainer.add(bestScoreLabel);

            if (bestScoreLabel.width > 300) {
                bestScoreLabel.setScale(300 / bestScoreLabel.width * .8, 300 / bestScoreLabel.width);
            }
        }

        // if (GameVars.levelUnlocked && GameConstants.REWARDED_ADS) {

        //     levelTitleBackground.setTexture("texture_atlas_1", "board_cleared_background");

        //     menuTitleBackground.x = -330;
        //     menuTitleBackground.y = -200;

        //     levelTitle.x = menuTitleBackground.x + 30;
        //     levelTitle.y = menuTitleBackground.y + 20;

        //     nextLevelButton.x = 280;
        //     nextLevelButton.y = -156;

        //     if (capsule) {
        //         capsule.y = 140;
        //         iconHourglass.y = 255;
        //         bestScoreLabel.y = 255;
        //     }

        //     const unlockedLevelContainer = new UnlockedLevelContainer(this.scene);
        //     scaledItemsContainer.add(unlockedLevelContainer);
        // }

        this.scene.tweens.add({
            targets: nextLevelButton,
            scaleX: 1.15,
            scaleY: 1.15,
            duration: 1000,
            ease: Phaser.Math.Easing.Cubic.InOut,
            yoyo: true,
            repeat: -1
        });

        this.scene.tweens.add({
            targets: scaledItemsContainer,
            alpha: 1,
            scaleX: GameVars.scaleX,
            scaleY: 1,
            duration: 1500,
            delay: 1250,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    }

    private onClickNextLevel(): void {

        GameManager.nextLevel();
    }
}
